import UserManagementMain from "../components/user-management/UserMain"


function UserManagement(){
    return <UserManagementMain/>
}

export default UserManagement